export const ARBITRUM_GAS_PRICE = '0.1';
